// src/filter-operator.ts
var FILTER_OPERATORS = Object.freeze({
  EQ: "eq",
  NEQ: "neq",
  GT: "gt",
  GTE: "gte",
  LT: "lt",
  LTE: "lte",
  IN: "in",
  NIN: "nin",
  CONTAINS: "contains",
  STARTS_WITH: "startsWith",
  ENDS_WITH: "endsWith",
  BETWEEN: "between",
  EXISTS: "exists",
  REGEX: "regex",
  SOME: "some",
  HAS: "has",
  HAS_SOME: "hasSome",
  HAS_NONE: "hasNone",
  IS_NOT: "isNot",
  RAW: "raw"
});

// src/logical-operator.ts
var LOGICAL_OPERATORS = Object.freeze({
  AND: "AND",
  OR: "OR",
  NOT: "NOT"
});

// src/sort-direction.ts
var SORT_DIRECTIONS = Object.freeze({
  ASC: "asc",
  DESC: "desc"
});

// src/filter-operators/string-filter-operator.ts
import { oz } from "@vy/oz";
var StringFilterOperatorSchema = oz.union([
  oz.literal(FILTER_OPERATORS.EQ),
  oz.literal(FILTER_OPERATORS.IN),
  oz.literal(FILTER_OPERATORS.NIN),
  oz.literal(FILTER_OPERATORS.REGEX),
  oz.literal(FILTER_OPERATORS.CONTAINS)
]);

// src/filter-operators/boolean-filter-operator.ts
import { oz as oz2 } from "@vy/oz";
var BooleanFilterOperatorSchema = oz2.union([
  oz2.literal(FILTER_OPERATORS.EQ),
  oz2.literal(FILTER_OPERATORS.IN)
]);

// src/filter-operators/date-filter-operator.ts
import { oz as oz3 } from "@vy/oz";
var DateFilterOperatorSchema = oz3.union([
  oz3.literal(FILTER_OPERATORS.EQ),
  oz3.literal(FILTER_OPERATORS.LT),
  oz3.literal(FILTER_OPERATORS.GT),
  oz3.literal(FILTER_OPERATORS.LTE),
  oz3.literal(FILTER_OPERATORS.GTE)
]);

// src/filter-operators/enum-filter-operator.ts
import { oz as oz4 } from "@vy/oz";
var EnumFilterOperatorSchema = oz4.union([
  oz4.literal(FILTER_OPERATORS.EQ),
  oz4.literal(FILTER_OPERATORS.IN),
  oz4.literal(FILTER_OPERATORS.NIN)
]);

// src/filter-operators/number-filter-operator.ts
import { oz as oz5 } from "@vy/oz";
var NumberFilterOperatorSchema = oz5.union([
  oz5.literal(FILTER_OPERATORS.EQ),
  oz5.literal(FILTER_OPERATORS.GT),
  oz5.literal(FILTER_OPERATORS.GTE),
  oz5.literal(FILTER_OPERATORS.LT),
  oz5.literal(FILTER_OPERATORS.LTE)
]);

// src/filter-operators/array-filter-operator.ts
import { oz as oz6 } from "@vy/oz";
var ArrayFilterOperatorSchema = oz6.union([
  oz6.literal(FILTER_OPERATORS.HAS_SOME),
  oz6.literal(FILTER_OPERATORS.HAS),
  oz6.literal(FILTER_OPERATORS.HAS_NONE)
]);

// src/filter-inputs/string-filter-input.ts
import { oz as oz7 } from "@vy/oz";
var StringFilterInputSchema = oz7.object({
  field: oz7.string(),
  operator: StringFilterOperatorSchema,
  value: oz7.string()
}).openapi("StringFilterInput");

// src/filter-inputs/number-filter-input.ts
import { oz as oz8 } from "@vy/oz";
var NumberFilterInputSchema = oz8.object({
  field: oz8.string(),
  operator: NumberFilterOperatorSchema,
  value: oz8.union([oz8.number(), oz8.array(oz8.number())])
}).openapi("NumberFilterInput");

// src/filter-inputs/boolean-filter-input.ts
import { oz as oz9 } from "@vy/oz";
var BooleanFilterInputSchema = oz9.object({
  field: oz9.string(),
  operator: BooleanFilterOperatorSchema,
  value: oz9.union([oz9.boolean(), oz9.array(oz9.boolean())])
}).openapi("BooleanFilterInput");

// src/filter-inputs/enum-filter-input.ts
import { oz as oz10 } from "@vy/oz";
var EnumFilterInputSchema = oz10.object({
  field: oz10.string(),
  operator: EnumFilterOperatorSchema,
  value: oz10.union([oz10.string(), oz10.array(oz10.string())])
}).openapi("EnumFilterInput");

// src/filter-inputs/date-filter-input.ts
import { oz as oz11 } from "@vy/oz";
var DateFilterInputSchema = oz11.object({
  field: oz11.string(),
  operator: DateFilterOperatorSchema,
  value: oz11.union([oz11.string().datetime(), oz11.array(oz11.string().datetime())])
}).openapi("DateFilterInput");

// src/filter-inputs/array-filter-input.ts
import { oz as oz12 } from "@vy/oz";
var ArrayFilterInputSchema = oz12.object({
  field: oz12.string(),
  operator: ArrayFilterOperatorSchema,
  value: oz12.union([oz12.string(), oz12.array(oz12.string())])
}).openapi("ArrayFilterInput");

// src/field-type.ts
var FIELD_TYPES = Object.freeze({
  COMPOSITE: "composite",
  RELATION: "relation",
  ARRAY_COMPOSITE: "array_composite"
});
export {
  ArrayFilterInputSchema,
  ArrayFilterOperatorSchema,
  BooleanFilterInputSchema,
  BooleanFilterOperatorSchema,
  DateFilterInputSchema,
  DateFilterOperatorSchema,
  EnumFilterInputSchema,
  EnumFilterOperatorSchema,
  FIELD_TYPES,
  FILTER_OPERATORS,
  LOGICAL_OPERATORS,
  NumberFilterInputSchema,
  NumberFilterOperatorSchema,
  SORT_DIRECTIONS,
  StringFilterInputSchema,
  StringFilterOperatorSchema
};
